/**
 * Venue Service
 * Register Angular Services for Vendor with type=venue
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Venue', ['$resource', function($resource){
    return $resource('/api/v2/venue/:id');
}]);
